var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomizerUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16.5V8.35L8.9 10.95L7.5 9.5L12.5 4.5L17.5 9.5L16.1 10.95L13.5 8.35V16.5H11.5ZM6.5 20.5C5.95 20.5 5.47917 20.3042 5.0875 19.9125C4.69583 19.5208 4.5 19.05 4.5 18.5V15.5H6.5V18.5H18.5V15.5H20.5V18.5C20.5 19.05 20.3042 19.5208 19.9125 19.9125C19.5208 20.3042 19.05 20.5 18.5 20.5H6.5Z",
    fill: "#1F534D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizerUpload);
export default __webpack_public_path__ + "static/media/customizer-upload.1a2d20f312d3854706b1b1bcbc2583b3.svg";
export { ForwardRef as ReactComponent };